import * as React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { getImgPath } from '../store/StringTool';
import { useSelector, useDispatch } from 'react-redux';
import { settingActions, settingObj } from '../store/SettingSlice';
import HeroJson from '../store/hero.json';


export default function CharacterAllDetail() {

    const dispatch = useDispatch();
    const settingData = useSelector(state => state.settingData);

    function backTap() {
        dispatch(settingActions.setCharacterWrapperIndex(1));
    }

    return (
        <Stack sx={{
            bgcolor: 'black',
            width: 1,
            minHeight: window.innerHeight,
            alignItems: 'center',
        }}>
            <Box
                component={'img'}
                src={getImgPath('part5/skin_orange.jpg')}
                sx={{
                    position: 'absolute',
                    width: 1,
                    height: 1,
                    zIndex: 2,
                    objectFit: 'fill',
                }} />

            <Box
                component={'img'}
                src={getImgPath('part5/style_orange.png')}
                sx={{
                    position: 'absolute',
                    width: 0.85,
                    zIndex: 2,
                    top: '210px',
                    objectFit: 'contain',
                }} />


            {/* 导航 */}
            <Stack sx={{
                position: 'absolute',
                height: '110px',
                width: 1,
                top: '90px',
                flexDirection: 'row',
                alignItems: 'center',
                zIndex: 20,
            }}>
                <Box sx={{
                    position: 'absolute',
                    width: 1,
                    height: '1px',
                    bgcolor: '#4B1515',
                    bottom: 0,
                    zIndex: 3,
                }} />

                <Box
                    onClick={backTap}
                    component={'img'}
                    src={getImgPath('ico_back.png')}
                    sx={{
                        WebkitFilter: 'brightness(80%)',
                        filter: 'brightness(80%)',
                        width: '55px',
                        height: '55px',
                        transitionDuration: '0.3s',
                        cursor: 'pointer',
                        ml: 25,
                        '&:hover': {
                            WebkitFilter: 'brightness(120%)',
                            filter: 'brightness(120%)',
                        },
                    }} />

                <Typography sx={{
                    color: '#B32228',
                    ml: 2,
                    fontSize: 30,
                    fontWeight: 'bold',
                    mr: 50,
                }}>
                    {HeroJson[settingData.detailName][settingData.lang]['name']}
                </Typography>
            </Stack>

            {/* 大图 */}
            <Box
                component={'img'}
                src={getImgPath(`all/${settingData.detailName}_big.png`)}
                sx={{
                    position: 'absolute',
                    zIndex: 21,
                    height: 1,
                    minHeight: '600px',
                    maxHeight: '1200px',
                    right: '-100px',
                }} />

            {/* 左边 */}
            <Stack sx={{
                zIndex: 11,
                position: 'absolute',
                left: '200px',
                height: 1,
                justifyContent: 'center',
                pt:17,
            }}>
                <NameItem />
                <InfoItem title={settingData.langDic['style']} detail={HeroJson[settingData.detailName][settingData.lang]['style'].toUpperCase()} />
                <InfoItem title={settingData.langDic['birthday']} detail={HeroJson[settingData.detailName][settingData.lang]['birthday'].toUpperCase()} />
                <InfoItem title={settingData.langDic['height']} detail={HeroJson[settingData.detailName][settingData.lang]['height'].toLowerCase()} />

                <Stack sx={{
                    flexDirection: 'row',
                    mt: 3,
                }}>
                    <Box
                        component={'img'}
                        src={getImgPath(`all/${settingData.detailName}_small.png`)}
                        sx={{
                            height: '80px',
                            mr: 2,
                            backgroundSize: '100% 100%',
                            backgroundImage: `url(${getImgPath('skil_super_bg.png')})`,
                        }} />

                    {
                        HeroJson[settingData.detailName]['skill_num'].map((value, i) => {
                            return <Box
                                key={i}
                                component={'img'}
                                src={getImgPath(`all/${settingData.detailName}_skill${i}.png`)}
                                sx={{
                                    width: '70px',
                                    height: '70px',
                                    mx: 2,
                                    borderRadius: '38px',
                                    border: 1,
                                    borderWidth: '3px',
                                    borderColor: '#00000066'
                                }} />
                        })
                    }

                </Stack>

            </Stack>

        </Stack>
    );
}

function NameItem(props) {
    const settingData = useSelector(state => state.settingData);

    return (
        <Stack sx={{
            zIndex: 3,
            my: 1,
            flexDirection: 'row',
            alignItems: 'center',
        }}>
            <Stack sx={{
                position: 'relative',
            }}>
                <Typography sx={{
                    fontSize: 60,
                    fontWeight: 'bold',
                    zIndex: 2,
                    color: 'white',
                    px: 2,
                }}>
                    {HeroJson[settingData.detailName][settingData.lang]['name']}
                </Typography>

                <Box sx={{
                    position: 'absolute',
                    height: '20px',
                    width: 1,
                    bgcolor: '#D77C37',
                    bottom: '5px',
                    zIndex: 1,
                }} />

            </Stack>

            <Box
                component={'img'}
                src={getImgPath(`type/${HeroJson[settingData.detailName]['type']}.png`)}
                sx={{
                    ml: 6,
                    width: '70px',
                    height: '70px',
                    borderRadius: '38px',
                    border: 1,
                    borderWidth: '3px',
                    borderColor: '#00000066'
                }} />

        </Stack>
    );
}

function InfoItem(props) {
    return (
        <Stack sx={{
            flexDirection: 'row',
            mt: '10px',
        }}>

            <Typography sx={{
                fontSize: 14,
                fontWeight: 'bold',
                color: '#C1BDBB',
                bgcolor: '#00000066',
                width: '100px',
                textAlign: 'end',
                py: '3px',
                pr: '8px',
                mr: '4px',
            }}>
                {props.title}
            </Typography>

            <Typography sx={{
                fontSize: 14,
                fontWeight: 'bold',
                color: '#C1BDBB',
                bgcolor: '#000000bb',
                py: '3px',
                pl: '10px',
                pr: '15px',

            }}>
                {props.detail}
            </Typography>

        </Stack>
    );
}